import { Button, Card, message, Spin } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { HiCloudDownload } from 'react-icons/hi';


interface SheetData {
  [key: string]: any[][]
}


function ExcelViewer({
  url,
  noHeader,
}: {
  url: string
  noHeader?: boolean
}) {
  const [sheetData, setSheetData] = useState<SheetData>({});
  const [activeSheet, setActiveSheet] = useState<string>("");
  // const [excelData, setExcelData] = useState<any[]>([]);
  const [sheetNames, setSheetNames] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadExcelFile = async () => {
      // Import xlsx dynamically
      const XLSX = await import("xlsx");

      try {
        setLoading(true);

        const response = await fetch(url);
        const arrayBuffer = await response.arrayBuffer();
        const workbook = XLSX.read(arrayBuffer, { type: "array" });

        const sheets = workbook.SheetNames;

        const sheetsData: SheetData = {}
        workbook.SheetNames.forEach((sheetName) => {
          const worksheet = workbook.Sheets[sheetName]
          const jsonData = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
            defval: "",
            raw: false,
          })
          sheetsData[sheetName] = jsonData as any[][]
        })

        setSheetNames(sheets);
        setSheetData(sheetsData)
        setActiveSheet(workbook.SheetNames[0] || "")
      } catch (error) {
        console.error("Error loading Excel file:", error);
        message.error("Failed to load Excel file");
      } finally {
        setLoading(false);
      }
    };

    loadExcelFile();
  }, [url]);


  // if we want to download XLS from the data
  // const downloadFile = async () => {
  //   if (!sheetData || Object.keys(sheetData).length === 0) return

  //   try {
  //     const XLSX = await import("xlsx")
  //     const workbook = XLSX.utils.book_new()

  //     Object.entries(sheetData).forEach(([sheetName, data]) => {
  //       const worksheet = XLSX.utils.aoa_to_sheet(data)
  //       XLSX.utils.book_append_sheet(workbook, worksheet, sheetName)
  //     })

  //     XLSX.writeFile(workbook, `edited_${file?.name || "spreadsheet.xlsx"}`)
  //   } catch (error) {
  //     console.error("Error downloading file:", error)
  //   }
  // }

  const data = sheetData?.[activeSheet] || []
  const columnHeaders = data.length > 0 ? Object.keys(data[0]) : [];

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="w-full overflow-x-auto">
      <Card className="p-0" bodyStyle={{ padding: 0 }}>
        <div className="overflow-auto max-h-[600px]"
        >
          <table className="w-full border-collapse">
            {!noHeader && <thead className="sticky top-0 bg-card z-10 border-b border-gray-300">
              <tr className="bg-[#1f1f1f]">
                <th className="p-2 text-xs font-medium w-12">#</th>
                {columnHeaders.map((header, colIndex) => (
                  <th
                    key={colIndex}
                    className="p-2"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>}
            <tbody>
              {data.map((row, rowIndex) => (
                <tr key={rowIndex} className="hover:bg-[#1f1f1f]">
                  {!noHeader && (
                    <td className="p-2 text-xs font-medium text-center">
                      {rowIndex + 1}
                    </td>
                  )}  {columnHeaders.map((_, colIndex) => {
                    const cellValue = row?.[colIndex] || ""
                    return (
                      <td key={colIndex} className={classNames("p-0 relative group", noHeader && rowIndex === 0 && "bg-[#1f1f1f]")}>
                        <div className="flex items-center justify-between min-h-[40px]">
                          <div className="flex-1 p-2 text-sm">{cellValue}</div>
                        </div>
                      </td>
                    )
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between items-center my-4 flex-wrap gap-4">
          <Button
            icon={<HiCloudDownload />}
            type="primary"
            href={url}
            download
          >
            Download
          </Button>
          <div className="flex gap-2 flex-wrap">
            {sheetNames.map((sheetName) => (
              <Button
                key={sheetName}
                type={activeSheet === sheetName ? "primary" : "default"}
                size="small"
                onClick={() => setActiveSheet(sheetName)}
              >
                {sheetName}
              </Button>
            ))}
          </div>
        </div>
      </Card>
    </div>
  )
}

export default ExcelViewer